<template>
	<div class="bodily">
		<div class="insert-title">第三步、填寫體型信息</div>
		<el-form
			:model="formData"
			:rules="rules"
			
			ref="bodily"
		>
			<el-row :gutter="10">
			  <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
				  <el-form-item
				  	label="身高"
				  	prop="height"
				  >
				  	<el-input
				  		v-model="formData.height"
				  		placeholder="請輸入身高"
				  	><template slot="append">cm</template></el-input>
				  	
				  </el-form-item>
			  </el-col>
			  <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
				  <el-form-item
				  	label="體重"
				  	prop="weight"
				  >
				  	<el-input
				  		v-model="formData.weight"
				  		placeholder="請輸入體重"
				  	>
				  	<template slot="append">kg</template>
				  	</el-input>
				  </el-form-item>
			  </el-col>
			  <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
				  <el-form-item
				  	label="腰圍"
				  	prop="waist"
				  >
				  	<el-input
				  		v-model="formData.waist"
				  		placeholder="若不填腰圍,則根據您的信息自動生成"
				  	>
				  	<template slot="append">cm</template>
				  	</el-input>
				  	
				  </el-form-item>
			  </el-col>
			  <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
				  <el-form-item
				  	label="臀圍"
				  	prop="hip"
				  >
				  <!-- 若不填臀圍,則根據您的信息自動生成 -->
				  	<el-input
				  		v-model="formData.hip"
				  		placeholder="若不填臀圍,則根據您的信息自動生成"
				  	><template slot="append">cm</template></el-input>
				  	
				  </el-form-item>
			  </el-col>
			  <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
				  <el-form-item
				  	label="體脂率"
				  	prop="fat"
				  	v-if="formData.type != 'M22'"
				  >
				  	<el-input
				  		v-model="formData.fat"
				  		placeholder="若不填體脂率,則根據您的信息自動生成"
				  	><template slot="append">%</template></el-input>
				  
				  </el-form-item>
			  </el-col>
			  <el-col :span="24" class="text-importent">請注意，自動生成的腰圍、臀圍信息可能與您的真實情況偏差較大，我們強烈建議您填寫準確的腰圍、臀圍數據</el-col>
			  <el-col :span="24">
				  <div class="footer-btn">
				  	<el-button @click="handlePrev" class="prev qjc-fts-16 qjc-block">上一步</el-button>
				  	<el-button @click="next" class="next qjc-fts-16 qjc-block">{{formData.goods_id == 6 ? '確認提交' : '下一步'}}</el-button>
				  </div>
			  </el-col>
			</el-row>

		</el-form>
		
	</div>
</template>

<script>
	import { newQuestionsSubmit, isHKPhone } from '../../../js/axios'
	
	let numberInput = function (value) {
		var price = '' + value;
		price = price
		    .replace(/[^\d.]/g, '') // 清除“數字”和“.”以外的字符
		    .replace(/\.{2,}/g, '.') // 只保留第一個. 清除多餘的
		    .replace('.', '$#$')
		    .replace(/\./g, '')
		    .replace('$#$', '.')
		    .replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3'); // 只能輸入兩個小數
		if (price.indexOf('.') < 0 && price != '') {
		    // 以上已經過濾，此處控制的是如果沒有小數點，首位不能為類似於 01、02的金額
		    price = parseFloat(price);
		}
		return price
	}
	export default{
		name: "bodily",
		data() {
			var heightVerify = (rule, value, callback) => {
				if(isNaN(numberInput(value)) || numberInput(value) < 130 || numberInput(value) > 200){
					callback(new Error('身高為130~200'));
				}else{
					callback();
				}
			}
			var weightVerify = (rule, value, callback) => {
				if(isNaN(numberInput(value)) || numberInput(value) < 30 || numberInput(value) > 160){
					callback(new Error('體重為30~160'));
				}else{
					callback();
				}
			}
			var waistVerify = (rule, value, callback) => {
				if(value != '') {
					if(isNaN(numberInput(value)) || numberInput(value) < 40 || numberInput(value) > 150){
						callback(new Error('腰圍為40~150'));
					}else{
						callback();
					}
				}
				if(value == '') {
					callback();
				}
				// if(this.hasFb){
				// 	if(value != '') {
				// 		if(isNaN(numberInput(value)) || numberInput(value) < 40 || numberInput(value) > 150){
				// 			callback(new Error('腰圍為40~150'));
				// 		}else{
				// 			callback();
				// 		}
				// 	} else {
				// 		callback(new Error('請輸入腰圍'));
				// 	}
				// } else {
				// 	if(value != '') {
				// 		if(isNaN(numberInput(value)) || numberInput(value) < 40 || numberInput(value) > 150){
				// 			callback(new Error('腰圍為40~150'));
				// 		}else{
				// 			callback();
				// 		}
				// 	}
				// 	if(value == '') {
				// 		callback();
				// 	}
				// }
			}
			var hipVerify = (rule, value, callback) => {
				if(value != '') {
					if(isNaN(numberInput(value)) || numberInput(value) < 60 || numberInput(value) > 165){
						callback(new Error('臀圍為60~165'));
					}else{
						callback();
					}
				}
				if(value == '') {
					callback();
				}
				// if(this.hasFb){
				// 	if(value != '') {
				// 		if(isNaN(numberInput(value)) || numberInput(value) < 60 || numberInput(value) > 165){
				// 			callback(new Error('臀圍為60~165'));
				// 		}else{
				// 			callback();
				// 		}
				// 	} else {
				// 		callback(new Error('請輸入臀圍'));
				// 	}
				// } else {
					
				// }
			}
			var fatVerify = (rule, value, callback) => {
				if(value != '') {
					if(isNaN(numberInput(value)) || numberInput(value) && numberInput(value) < 3 || numberInput(value) > 75){
						callback(new Error('體脂率為3~75'));
					}else{
						callback();
					}
				}
				if(value == '') {
					callback();
				}
			}
			
			return {
				rules: {
					height: [
						{ required: true, message: '請填寫您的身高', trigger: 'blur' },
						{ validator: heightVerify, trigger: 'blur' }
					],
					weight: [
						{ required: true, message: '請填寫您的體重', trigger: 'blur' },
						{ validator: weightVerify, trigger: 'blur' }
					],
					waist: [
						{ required: false, message: '請填寫您的腰圍', trigger: 'blur' },
						{ validator: waistVerify, trigger: 'blur' }
					],
					hip: [
						{ required: false, message: '請填寫您的臀圍', trigger: 'blur' },
						{ validator: hipVerify, trigger: 'blur' }
					],
					fat: [
						// { required: true, message: '請填寫您的體脂率', trigger: 'blur' },
						{ validator: fatVerify, trigger: 'blur' }
					]
				},
			}
		},
		props: ['formData'],
		inject: ['handleRefresh'],
		mounted() {
			
		},
		methods: {
			//下一步
			next() {
				this.$refs.bodily.validate((isSuc, err) => {
					if(isSuc){
						if(this.formData.goods_id == 6) {
							
							this.formData.loa = isHKPhone(this.phone) ? '00852' : '86';
							this.formData.goods_id =  this.formData.package ? this.formData.package : this.formData.goods_id;
							
							let comData = {...this.formData}
							
							delete comData.package;
							delete comData.examine;
							delete comData.dbp;
							delete comData.sbp;
							
							newQuestionsSubmit(comData).then(res => {
								
								this.submiting = false;
								
								if(res.code == 200){
									this.updateShow = false;
									this.$myAlert({
										title: this.formData.id ?'修改成功':'錄入成功',
										callback: () => {
											this.$emit('clearData', {});
											this.$emit('checkTab', 'Personal');
											this.handleRefresh()
										}
									});
								}else{
									this.updateShow = false;
									this.$myAlert({
										type: 'fail',
										content: res.msg
									});
								}
							});
							
							
						} else {
							if(this.formData.type == 'M22') {
								this.$emit('checkTab', 'BiochemicalM22');
							} else {
								this.$emit('checkTab', 'Biochemical');
							}
						}
					}
				});
			},
			handlePrev() {
				if(this.formData.type == 'M22') {
					this.$emit('checkTab', 'Personal');
				} else {
					this.$emit('checkTab','Questions');
				}
			},
		}
	}
</script>

<style scoped>

	.bodily >>> .el-input{
		width: 100%;
		max-width: 400px;
		height: 32px;
	}
	.bodily >>> .el-input input{
		width: 100%;
		height: 32px;
	}

	.bodily >>> .el-form-item__content{
		font-size: 14px;
	}
	
	.el-form>>>.el-form-item__error {
		position: absolute;
	}
	
	.bodily >>> .el-form-item__label{
		float: none;
	}

	
</style>
<style lang="scss" scoped>
	.bodily{
		padding-top: 50px;
		
		.insert-title {
			position: relative;
			font-size: 16px;
			font-family: PingFangSC-Medium, PingFang SC;
			font-weight: 500;
			color: #293033;
			line-height: 16px;
			padding-bottom: 15px;
			border-bottom: 1px solid #E5E8F5;
			margin-bottom: 8px;
			
			&::before{
				position: absolute;
				left: -24px;
				top: 0;
				content: '';
				width: 4px;
				height: 20px;
				background-color: #6883FB;
			}
		}
		
		.el-form-item{
			// margin: 24px 80px 0 0;
			// min-width: 500px;
			width: 100%;
			
			
		}
		.next-form-item {
			margin-right: 0 !important;
		}
		.footer-btn {
			display: flex;
			justify-content: center;
			align-items: center;
			margin-top: 40px;
		}
				
		.next{
			width: 96px;
			height: 34px;
			border-radius: 17px;
			border: none;
			font-size: 14px;
			font-family: PingFangSC-Medium, PingFang SC;
			font-weight: 500;
			color: #fff;
		}
		.prev {
			width: 96px;
			height: 34px;
			border-radius: 17px;
			border: 1px solid #6883FB;
			font-size: 14px;
			font-family: PingFangSC-Medium, PingFang SC;
			font-weight: 500;
			color: #6883FB;
			background-color: #fff;
			margin-right: 24px;
		}
	}
	
	.text-importent{
		color: #ff0039;
		font-size: 14px;
	}
</style>
